// extracted by mini-css-extract-plugin
module.exports = {"Content":"CompaniesContainer_Content__2mMVA"};